import { NgModule } from '@angular/core';
import { NumericCellNavDirective } from './numeric-cell.directive';

@NgModule({
  declarations: [
    NumericCellNavDirective
  ],
  exports: [
    NumericCellNavDirective
  ]
})
export class TableCellModule {
}
